import { put, call, take, fork, takeEvery } from 'redux-saga/effects';

export default function* tokenSaga() {
    while (true) {
    const action = yield take('SETTOKEN'); // yield take返回监听到的action
    // console.log(action, 'action');
    yield put(action);
  }
}